import type { ICalendarEvent } from '@/features/calendar/interfaces'
import type { TCalendarView } from '@/features/calendar/types'
import { formatDate } from 'date-fns'

import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { useMemo } from 'react'

import { Button } from '@/components/ui/button'

import { getTrainingsCount, navigateDate, rangeText } from '@/features/calendar/helpers'
import { useCalendar } from '../../contexts/use-calendar'

interface IProps {
  view: TCalendarView
  data: ICalendarEvent[]
}

export function DateNavigator({ view, data }: IProps) {
  const { selectedDate, setSelectedDate } = useCalendar()

  const month = formatDate(selectedDate, 'MMMM')
  const year = selectedDate.getFullYear()

  const bookingCount = useMemo(() => getTrainingsCount(data, selectedDate, view), [data, selectedDate, view])
  const handlePrevious = () => setSelectedDate(navigateDate(selectedDate, view, 'previous'))
  const handleNext = () => setSelectedDate(navigateDate(selectedDate, view, 'next'))

  return (
    <div className="space-y-0.5">
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold">
          {month}
          {' '}
          {year}
        </span>
        <Badge>
          {bookingCount}
          {' '}
          events
        </Badge>
      </div>

      <div className="flex items-center gap-2">
        <Button variant="outline" className="size-6.5 px-0 [&_svg]:size-4.5" onClick={handlePrevious}>
          <ChevronLeft />
        </Button>

        <p className="text-sm text-t-tertiary">{rangeText(view, selectedDate)}</p>

        <Button variant="outline" className="size-6.5 px-0 [&_svg]:size-4.5" onClick={handleNext}>
          <ChevronRight />
        </Button>
      </div>
    </div>
  )
}
